export default __webpack_public_path__ + "static/media/ahri-bg.71d049ef.jpg";